import { InjectionToken } from '@angular/core';
import { CompanyAsyncExportServiceModel } from '../models';

export const COMPANY_ASYNC_EXPORT_SERVICE_CONFIG: InjectionToken<CompanyAsyncExportServiceModel>
    = new InjectionToken<CompanyAsyncExportServiceModel>('COMPANY_ASYNC_EXPORT_SERVICE_CONFIG');
